import React from 'react';
import './Services.css'; // Importe o CSS customizado

function Services() {
  return (
    <section id="servicos" className="container my-5">
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {/* Inspeção Veicular */}
        <div className="col">
          <div
            className="card h-100 text-center shadow-sm service-card"
            style={{ borderTop: '4px solid #ea2325' }}
          >
            <div className="card-body">
              <i
                className="bi bi-clipboard-check service-icon"
                style={{ color: '#ea2325' }}
              ></i>
              <h5 className="card-title mt-3 service-title">Inspeção Veicular</h5>
              <p className="card-text service-text">
                Realizamos inspeções veiculares rigorosas, garantindo a segurança e a conformidade do seu veículo.
                Somos credenciados pelo DETRAN, assegurando qualidade em cada avaliação.
              </p>
            </div>
          </div>
        </div>
        {/* Identificação Veicular */}
        <div className="col">
          <div
            className="card h-100 text-center shadow-sm service-card"
            style={{ borderTop: '4px solid #01295c' }}
          >
            <div className="card-body">
              <i
                className="bi bi-car-front service-icon"
                style={{ color: '#01295c' }}
              ></i>
              <h5 className="card-title mt-3 service-title">Identificação Veicular</h5>
              <p className="card-text service-text">
                Utilizamos tecnologia de ponta para identificação veicular, garantindo precisão e agilidade nos registros.
                Facilite a regularização e o monitoramento do seu veículo com nosso serviço especializado.
              </p>
            </div>
          </div>
        </div>
        {/* Rede de Atendimento */}
        <div className="col">
          <div
            className="card h-100 text-center shadow-sm service-card"
            style={{ borderTop: '4px solid #01429b' }}
          >
            <div className="card-body">
              <i
                className="bi bi-people service-icon"
                style={{ color: '#01429b' }}
              ></i>
              <h5 className="card-title mt-3 service-title">Rede de Atendimento</h5>
              <p className="card-text service-text">
                Contamos com a maior rede de Estações de Controle Veicular (ECV) do RN, garantindo atendimento ágil e eficiente em diversas localidades.
              </p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </section>
  );
}

export default Services;
